import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../api";
import SpinnerMain from "./Spinner";
const PermissionsUserRouter = ({ children, column, type }) => {
    const [loading, setLoading] = useState(true);
    const [PermissionGranted, setPermissionGranted] = useState(null);
    useEffect(() => {
        const CheckPermission = async () => {
            try {
                const response = await api.get("/api/permission-varify/", {
                    params: {
                        PermissionColumn: column,
                        PermissionType: type,
                    },
                });
                const result = response.data;
                setPermissionGranted(result.is_permission);
            } catch (error) {
                console.error("Error verifying superuser:", error);
                setPermissionGranted(false);
            } finally {
                setLoading(false);
            }
        };
        CheckPermission();
    }, [column, type]);
    if (loading) {
        return <SpinnerMain />;
    }

    if (!PermissionGranted) {
        return (
            <Navigate
                to="/no_permission"
                replace
            />
        ); // Redirect to home or login page
    }

    return children;
};

export default PermissionsUserRouter;
